import { DragDropContext } from 'react-beautiful-dnd';
import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import { ColumnBoard } from '..';
import { WINDOW_WIDTH } from '../../../../../../constants/ui';


const Board = ({
  invoiceStatuses, onDragEnd, onDragStart, onDragUpdate, isDragging,
  updateDroppable, columnRowHeight, windowWidth,
}) => (
  <div
    className="pipe-view__column-row"
    style={windowWidth < WINDOW_WIDTH.SMALL ? { height: columnRowHeight } : {}}
  >
    <DragDropContext onDragEnd={onDragEnd} onDragUpdate={onDragUpdate} onDragStart={onDragStart}>
      {invoiceStatuses.map(invoiceStatus => (
        <ColumnBoard
          isDragging={isDragging}
          updateDroppable={updateDroppable}
          invoiceStatus={invoiceStatus}
          key={`invoice - ${invoiceStatus.id}`}
        />
      ))}
    </DragDropContext>
  </div>
);

Board.propTypes = {
  invoiceStatuses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onDragEnd: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
  onDragUpdate: PropTypes.func.isRequired,
  updateDroppable: PropTypes.number,
  isDragging: PropTypes.bool.isRequired,
  columnRowHeight: PropTypes.string.isRequired,
  windowWidth: PropTypes.number.isRequired,
};

Board.defaultProps = {
  updateDroppable: null,
};

export default Board;
